import Table from "@/common/components/Table";
import { LargeCard } from "../../stats/subs/LargeCard";
import {
  fundAllocationRequestTableHeaders,
  fundAllocationRequestTableKeys,
  getFundAllocationRequestTableData,
  pharmacyHeadFinancialCards,
} from "../data";
import { StatisticWrapper } from "../style";
import { Pagination } from "@/common/components/pagination";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { useCallback, useMemo, useState } from "react";
import { KeyValueObj } from "@/common/types";

const PharmacyHeadStat = () => {
  const [fundAllocationRequestPerpage, setFundAllocationRequestPerpage] =
    useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentRow, setCurrentRow] = useState<any>();
  const {
    data: fundAllocationRequestData,
    meta: fundAllocationRequestMeta,
    loading: fundAllocationRequestLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${fundAllocationRequestPerpage}&page=${fundAllocationRequestPerpage}`
  );

  const handlePharmacyHeadDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleFundAllocationRequestView = useCallback(() => {
    alert("coming soon");
  }, []);

  const fundAllocationRequestDropdownOptions = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleFundAllocationRequestView }]
        : [{ label: "View", action: handleFundAllocationRequestView }],
    [handleFundAllocationRequestView, currentRow]
  );
  return (
    <StatisticWrapper>
      <div className="card-wrapper">
        {pharmacyHeadFinancialCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>

      {/* table */}
      <div className="table-wrapper">
        <Table
          tableHeaders={fundAllocationRequestTableHeaders}
          tableKeys={fundAllocationRequestTableKeys}
          tableData={getFundAllocationRequestTableData(
            fundAllocationRequestData
          )}
          tableTitle="Fund Allocation Request"
          tableSubtitle={
            (fundAllocationRequestMeta?.total_count ?? "0") + " Requests"
          }
          loading={fundAllocationRequestLoading}
          handleDropDownClicked={handlePharmacyHeadDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={fundAllocationRequestDropdownOptions}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={fundAllocationRequestMeta?.total_pages}
          onNextPage={(event: any) =>
            setFundAllocationRequestPerpage(event.selected)
          }
          onPerPageChange={(event: any) =>
            setFundAllocationRequestPerpage(event?.target?.value)
          }
        />
      </div>
    </StatisticWrapper>
  );
};

export default PharmacyHeadStat;
